import React from "react";
import Header from "../sections/Header";
import Footer from "../sections/Footer";
import "../style/style.css";
import useKontentServiceApi from "../services/useKontentServiceApi";
import { kontentVariables } from "../utils";

const PrivacyPolicyPage: React.FC = () => {
  const { data, loading } = useKontentServiceApi(
    kontentVariables.privacyPolicyPage
  );
  return (
    <>
      <Header loading={loading} />
      <main className="container">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="privacy-policy-content py-5"
                style={{ marginTop: "60px" }}
              >
                <h3 className="mb-4 text-left">
                  {data?.elements?.privacy_policy_title?.value}
                </h3>
                {data?.elements?.privacy_policy_content?.value ? (
                  <div
                    className="privacy-policy-text text-left"
                    dangerouslySetInnerHTML={{
                      __html: data.elements.privacy_policy_content.value,
                    }}
                  />
                ) : (
                  <div className="privacy-policy-text text-left">
                    <p>Loading privacy policy content...</p>
                    {!loading && (
                      <p>
                        No content available. Please check Kontent.ai
                        configuration.
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
